
export enum OrderDepthVolumeChange {
    UP = "UP",
    DOWN = "DOWN",
    NO_CHANGE = "NO_CHANGE"
}
